// src/components/Layout.jsx
import React, { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import Sidebar from './Sidebar';
import { MobileNavProvider } from '../context/MobileNavContext';

const PageLoader = () => (
    <div className="flex justify-center items-center h-[60vh] bg-gray-50">
        <div className="w-9 h-9 border-4 border-gray-200 border-t-indigo-500 rounded-full animate-spin" />
    </div>
);

const Layout = () => {
    const location = useLocation();
    // Hide sidebar on Role Select page only
    const pathname = (location?.pathname || '').replace(/\/+$/, '') || '/';
    const hideSidebar = pathname === '/select-role';

    return (
        <MobileNavProvider>
            {/*
              Document-flow shell (desktop-first):
              - Page scrolls with the window (footer stays after content, never overlays it)
              - Mobile drawer still works via Sidebar + MobileNavContext
              - Table wheel-trap is handled in CSS (overflow-y: hidden on horizontal scrollers)
            */}
            <div className="flex flex-col min-h-screen bg-gray-50">
                <Header showMenuButton={!hideSidebar} />

                <div className="flex flex-1 w-full min-w-0 relative">
                    {!hideSidebar && <Sidebar />}

                    <main className="flex-1 min-w-0 w-full">
                        <div className="w-full min-w-0 p-2 xs:p-3 sm:p-4 lg:p-6 pb-[max(1rem,env(safe-area-inset-bottom))]">
                            <Suspense fallback={<PageLoader />}>
                                <Outlet />
                            </Suspense>
                        </div>
                    </main>
                </div>

                <Footer />
            </div>
        </MobileNavProvider>
    );
};

export default Layout;
